import React from "react"
import { Link } from "gatsby"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faTwitter
  // faFacebookSquare,
  // faInstagram
} from "@fortawesome/free-brands-svg-icons"

const componentsFooter = () => {
  // const data = useStaticQuery(graphql`
  //   query {
  //     pattern: file(relativePath: {eq: "pattern.jpg"}) {
  //     childImageSharp {
  //       fluid(maxWidth: 1920, quality: 90) {
  //         ...GatsbyImageSharpFluid_withWebp
  //       }
  //     }
  //   }
  // }
  // `)

  return (
    <footer className="footer">
      <div className="container">
        <div className="site">
          <Link to={`/`}>
            <svg viewBox="0 0 396 29" xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd" strokeLinejoin="round" strokeMiterlimit={2}>
              <desc>フロントセンセイ</desc>
              <path d="M38.632 1.1h-31.1c-3.3 0-6.65 2.9-7.4 6.25-.7 3.4 1.45 6.3 4.75 6.3h19.05c.3 0 .45.25.35.5l-5.85 14.15h16.3l8.25-19.85s3.1-7.35-4.35-7.35zM78.332 11.45c.25 0 .5.25.45.55l-1.1 4.95c-.05.35-.35.55-.65.55h-11.6c-.25 0-.5-.25-.45-.55l1.1-4.95c.05-.3.35-.55.65-.55h11.6zm10.35-10.3h-27.9c-7.45 0-8.9 7.3-8.9 7.3l-2.55 12.05s-1.65 7.3 5.75 7.3h27.9c7.45 0 8.9-7.3 8.9-7.3l2.55-12.05s1.65-7.3-5.75-7.3zM128.582 10.4l-1.85 4.9c-.1.3-.4.5-.75.5h-17.75c-3.3 0-6.7 2.9-7.4 6.3-.75 3.3 1.4 6.2 4.7 6.2h25.2c3.3 0 7.15-2.9 8.45-6.2l4.45-11.7h-15.05zm-2.8-3.05c.75-3.4-1.45-6.3-4.75-6.3h-13.5c-3.3 0-6.65 2.9-7.4 6.3-.7 3.35 1.45 6.25 4.75 6.25h13.5c3.3 0 6.7-2.9 7.4-6.25zM187.482 8.1h-14.5c-.3 0-.5-.3-.45-.55l1.6-7.55h-16.7l-6.05 28.35h16.75l1.5-7.2c.1-.3.35-.55.7-.55h14.5c3.3 0 6.7-2.85 7.4-6.25.75-3.4-1.4-6.25-4.75-6.25zM238.882 3l-16.25-.05c-.3 0-.5-.25-.45-.55l.5-2.4h-14.9l-.55 2.4c-.05.35-.35.55-.65.55h-.55c-2.8 0-5.7 2.45-6.3 5.35-.6 2.85 1.25 5.3 4.05 5.3h.5c.3 0 .5.3.45.6l-1.45 6.8s-1.65 7.3 5.75 7.3l24.2-.05c2.8 0 5.7-2.45 6.3-5.25.6-2.9-1.25-5.35-4.05-5.35h-16c-.25 0-.5-.25-.45-.55l.65-2.9c.05-.35.35-.6.7-.6h6.85c.3 0 .45.3.35.55l-.7 1.7h14l2.3-5.55s3.15-7.3-4.3-7.3zM278.582 10.4l-1.85 4.9c-.1.3-.4.5-.75.5h-17.75c-3.3 0-6.7 2.9-7.4 6.3-.75 3.3 1.4 6.2 4.7 6.2h25.2c3.3 0 7.15-2.9 8.45-6.2l4.45-11.7h-15.05zm-2.8-3.05c.75-3.4-1.45-6.3-4.75-6.3h-13.5c-3.3 0-6.65 2.9-7.4 6.3-.7 3.35 1.45 6.25 4.75 6.25h13.5c3.3 0 6.7-2.9 7.4-6.25zM338.882 3l-16.25-.05c-.3 0-.5-.25-.45-.55l.5-2.4h-14.9l-.55 2.4c-.05.35-.35.55-.65.55h-.55c-2.8 0-5.7 2.45-6.3 5.35-.6 2.85 1.25 5.3 4.05 5.3h.5c.3 0 .5.3.45.6l-1.45 6.8s-1.65 7.3 5.75 7.3l24.2-.05c2.8 0 5.7-2.45 6.3-5.25.6-2.9-1.25-5.35-4.05-5.35h-16c-.25 0-.5-.25-.45-.55l.65-2.9c.05-.35.35-.6.7-.6h6.85c.3 0 .45.3.35.55l-.7 1.7h14l2.3-5.55s3.15-7.3-4.3-7.3zM395.332 2.1c-.25-2-3.15-2.1-4.05-2.1h-12.5l-31.9 19.35c-.2.1-.3.35-.25.6.05.25.25.4.5.4h16.55c.3 0 .5.3.45.6l-1.5 7.3h18.25l2.65-12.4h-5.95c-.2 0-.25-.2-.1-.3l15-9.2s3.1-2.05 2.85-4.25z" fillRule="nonzero" />
            </svg>
            <br /><span>Web/デザイン/ビジネスを探求するブログ</span>
          </Link>
        </div>
        <ul className="sns">
          <li>
            <a href="https://twitter.com/FrontSensei" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faTwitter} />
              <span className="sr-only">Twitter</span>
            </a>
          </li>
          {/* <li>
            <a href="https://facebook.com/">
              <FontAwesomeIcon icon={faFacebookSquare} />
              <span className="sr-only">Facebook</span>
            </a>
          </li>
          <li>
            <a href="http://instagram.com/">
              <FontAwesomeIcon icon={faInstagram} />
              <span className="sr-only">Instagram</span>
            </a>
          </li> */}
        </ul>
      </div>
      {/* <div className="back">
        <Img
          fluid={data.pattern.childImageSharp.fluid}
          alt=""
          style={{ height: "100%"}}
          />
      </div> */}
    </footer>
  )
}

export default componentsFooter